import { GET_MY } from '../../containers/App/constants';
import { GENERATE_OPTIONS, REQUEST_BMP_TAX_CALCULATION, REQUEST_DWH_STATUS } from './constants';

export function calculateBmp(input, callback) {
  return {
    type: GET_MY,
    post: input,
    work: REQUEST_BMP_TAX_CALCULATION,
    gate: REQUEST_BMP_TAX_CALCULATION,
    callback,
    path: `/taxes/bmp/calculation`,
  };
}

export function generateOptions() {
  return {
    type: GET_MY,
    work: GENERATE_OPTIONS,
    gate: GENERATE_OPTIONS,
    post: {},
    path: `vehicles/generate-options`,
  };
}

export function getDWHStatus() {
  return {
    type: GET_MY,
    id: REQUEST_DWH_STATUS,
    work: REQUEST_DWH_STATUS,
    gate: REQUEST_DWH_STATUS,
    path: `dwh/status`,
  };
}
